import React, { useEffect, useState } from "react";
import { Table, Button } from "react-bootstrap";

export default function ContentTable({ args }) {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    document.querySelector(".container-fluid").style.padding = 0;
    document.getElementsByTagName("body")[0].style.backgroundColor = "#e2e3e5";

    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 120);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {showScrollTop && (
        <Button
          className="fixed bottom-10 right-10 !rounded-full p-3 !text-mg !font-bold"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          Back to top
        </Button>
      )}
      <div className="w-full text-center flex flex-col gap-3">
        <div className="rounded">
          <div className="flex ml-4 !mr-4">
            <div className="w-80 flex text-[14px] text-start items-end text-muted">
              <span className="text-muted">
                {args.rows.length ?? args.data.length} /{" "}
                {args.count || args.items} subscriptions found
              </span>
            </div>
          </div>
          <Table className="m-3" responsive>
            <thead className="rounded w-full table-light text-center">
              <tr key="tr-header-unique">
                <th className="rounded-s-lg !p-5 content-center"></th>
                {args.headers.map((item, index) => {
                  return (
                    <th
                      key={`unique-th-index-${index}`}
                      className={
                        (index === args.headers.length - 1
                          ? "rounded-r-lg"
                          : "") + " !p-5 content-center"
                      }
                    >
                      {item}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>{args.rows ?? null}</tbody>
          </Table>
        </div>
      </div>
    </>
  );
}
